import { t } from "i18next";
import { toast } from "react-hot-toast";
import { Modal } from "ui";

import { useDeleteFeedInsert } from "../../../apis";
import { DeleteFeedInsertModalProps } from "./DeleteFeedInsertModal.types";

import styles from "./DeleteFeedInsertModal.module.scss";

const DeleteFeedInsertModal = ({
  isOpen,
  id,
  onClose
}: DeleteFeedInsertModalProps) => {
  const deleteFeedInsert = useDeleteFeedInsert({
    onSuccess: () => {
      onClose();
      toast.success(t("Feed insert has been deleted successfully"));
    }
  });

  return (
    <Modal
      type="delete"
      isOpen={isOpen}
      title="Delete Feed Insert"
      isLoading={deleteFeedInsert.isLoading}
      okText="Delete"
      onOk={() => deleteFeedInsert.mutate(id)}
      contentClassName={styles.modal}
      onClose={onClose}
    >
      <p className={styles.modal_text}>
        {t("Are you sure you want to delete this feed insert?")}
      </p>
    </Modal>
  );
};

export default DeleteFeedInsertModal;
